(function() {
    'use strict';

    angular
        .module('dialysisApp')
        .controller('ProblemListDialogController', ProblemListDialogController);

    ProblemListDialogController.$inject = ['$timeout', '$scope', 'DiagnosisSearch', '$uibModalInstance', 'problem', 'ProblemList', '$state'];

    function ProblemListDialogController ($timeout, $scope, DiagnosisSearch, $uibModalInstance, problem, ProblemList, $state) {
        var vm = this;

        vm.problem = problem;
        vm.clear = clear;
        vm.datePickerOpenStatus = {};
        vm.openCalendar = openCalendar;
        vm.save = save;
        vm.editing = $state.current.name != "problem-list-view";

        vm.getDiagnosis = getDiagnosis;

        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function save () {
            vm.isSaving = true;
            if (vm.problem.id !== null) {
                ProblemList.update(vm.problem, onSaveSuccess, onSaveError);
            } else {
                ProblemList.save(vm.problem, onSaveSuccess, onSaveError);
            }
        }

        function onSaveSuccess (result) {
            $scope.$emit('dialysisApp:problemUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        }

        function onSaveError () {
            vm.isSaving = false;
        }

        vm.datePickerOpenStatus.startDate = false;
        vm.datePickerOpenStatus.endDate = false;

        function openCalendar (date) {
            vm.datePickerOpenStatus[date] = true;
        }

        function getDiagnosis(query) {
            if (query && query.length > 2) {
                DiagnosisSearch.query({query: query}, function (result) {
                    vm.diagnoses = result;
                });
            }
        }
    }
})();
